import type { MutationHookOptions } from '@apollo/client'
import {
  PeopleChartUpdateTeamMemberDocument,
  PeopleChartUpdateTeamMemberMutation,
  PeopleChartUpdateTeamMemberMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  PeopleChartUpdateTeamMemberMutation,
  PeopleChartUpdateTeamMemberMutationVariables
>

export const useUpdateMembership = (options?: Options) => {
  const [updateMembership, { loading }] = useMutation(PeopleChartUpdateTeamMemberDocument, {
    ...options,
    extractorFn: (data) => data.teamsMutations?.updateTeamsMembership,
  })

  return {
    loading,
    updateMembership,
  }
}
